<div class="save-map" *ngIf="map">
    <div *ngIf="!isLoading">
        <div class="container alert-red" *ngIf="unsavedLayers.length > 0">
            The following layers need saved before you can save the map:
            <ul>
                <li *ngFor="let layer of unsavedLayers">{{ layer.name }}</li>
            </ul>
        </div>
        <div class="container alert-red nonPublicLayerList" *ngIf="nonPublicLayers.length > 0">
            The following layers do not have public permissions and must be removed before this map can be marked public:
            <ul>
                <li *ngFor="let layer of nonPublicLayers">{{ layer.name }}</li>
            </ul>
        </div>
        <div>
            Title: <input type="text" placeholder="Enter map title here" [(ngModel)]="map.name" [disabled]="isSaving">
        </div>
        <div class="container">
            Description: <textarea rows="5" placeholder="Enter map description here"
                                   [(ngModel)]="map.description" [disabled]="isSaving"></textarea>
        </div>
        <div class="container">
            Create New Map <input id="isNewMap" type="checkbox" [(ngModel)]="isNewMap"
                                  [disabled]="(map.isSystem || isSaving) || disableCreateMap">
        </div>
        <div class="container" *ngIf="showPublic">
            Is Public <input id="isPublic" type="checkbox" checked="false" [(ngModel)]="map.isPublic" [disabled]="isSaving">
        </div>
        <div class="map-folder" *ngIf="userId">
            <h4>Select Map Folder</h4>
            <div class="container">
                <span>New Folder</span><input id="newFolder" checked="false" type="checkbox" [ngModel]="createNewFolder"
                                              (ngModelChange)="isNewFolder($event)" [disabled]="isSaving">
            </div>
            <div *ngIf="createNewFolder" class="container" [ngStyle]="{'color': (newFolder.name.length < 1) ? 'red' : 'black'}">
                New Folder Name:<input type="text" placeholder="Enter new folder name" [(ngModel)]="newFolder.name">
            </div>
            <div class="container">
                <label>
                    Parent Folder:
                    <select class="modifier-class " [ngModel]="parentFolderId"
                            (ngModelChange)="parentFolderSelected($event)">
                        <option *ngFor="let option of parentFolders; trackBy:folderTrack" [ngValue]="option.id">{{ option.name }}</option>
                    </select>
                </label>
            </div>
        </div>
        <div *ngIf="isSaving && nonPublicLayers.length <= 0">
            <div class="loader is-active padding-leader-3 padding-trailer-3">
                <div class="loader-bars"></div>
                <div class="loader-text">Saving..</div>
            </div>
        </div>
        <button class="btn btn-clear right" (click)="closeWindow()">Cancel</button>
        <button class="btn right" (click)="saveMap()"
                [disabled]="!map.name || isSaving || (createNewFolder && newFolder.name.length < 1)">
            Save
        </button>
    </div>
    <div *ngIf="isLoading">
        <div class="loader is-active padding-leader-3 padding-trailer-3">
            <div class="loader-bars"></div>
            <div class="loader-text">Loading...</div>
        </div>
    </div>
</div>
